import React from 'react';
interface Step {
  title: string;
  description?: string;
  icon?: React.ReactNode;
}
interface StepListProps {
  steps: Step[];
}
const BADGE_STYLES = ['bg-primary text-white', 'bg-brand-orange text-white', 'bg-lavande text-primary-dark'];
export function StepList({
  steps
}: StepListProps) {
  return <ol className="grid gap-8 sm:grid-cols-2 lg:grid-cols-4" data-id="element-536">
      {steps.map((step, index) => {
      const badgeStyle = BADGE_STYLES[index % BADGE_STYLES.length];
      return <li key={index} className="group flex flex-col items-center text-center" data-id="element-537">
            <div className={`${badgeStyle} flex items-center justify-center w-16 h-16 rounded-full shadow-md mb-5 transition-transform duration-300 group-hover:scale-110`} data-id="element-538">
              {step.icon ? <span className="animate-soft-bounce" data-id="element-539">{step.icon}</span> : <span className="font-heading font-extrabold text-2xl" data-id="element-540">
                  {index + 1}
                </span>}
            </div>
            <h3 className="font-heading font-bold text-lg text-primary-dark mb-2" data-id="element-541">
              {step.title}
            </h3>
            {step.description && <p className="text-sm text-muted-foreground leading-relaxed" data-id="element-542">
                {step.description}
              </p>}
          </li>;
    })}
    </ol>;
}